module.exports = __webpack_public_path__ + "ae611e526420cbd944105a01bb49344a.fbx";